import { render, staticRenderFns } from "./CprPlusContainer.vue?vue&type=template&id=48d57b91&scoped=true&"
import script from "./CprPlusContainer.vue?vue&type=script&lang=js&"
export * from "./CprPlusContainer.vue?vue&type=script&lang=js&"
import style0 from "./CprPlusContainer.vue?vue&type=style&index=0&id=48d57b91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d57b91",
  null
  
)

export default component.exports